import React, {FC, useState} from "react";
import {
 ICriticalHazards, IHarm,
    IProjectFailureMode, ISeverity,
} from "../types/types";

import {
    Chip,

    TableCell,

    TableRow,

    Tooltip
} from "@material-ui/core";

import {WarningChip} from "./reasonably_practicable_tests";



interface ILikelihoodProps {
    severities: ISeverity[]
    failure_mode: IProjectFailureMode
    critical_hazard?: ICriticalHazards
}



const likelihood_categories = [
    {level: 10000000, name: "AFP ≥ 10-3"},
    {level: 1e-3, name: "10-3 > AFP ≥ 10-4"},
    {level: 1e-4, name: "10-4 > AFP ≥ 10-5"},
    {level: 1e-5, name: "AFP < 10-5"},
    {level: -0.00001, name: "undefined"}
]

export const  render_likelihood_pill = (likleihood: number, name?:string) => {

    let level = 0

    for (let i = likelihood_categories.length -1; i > -1 ; i--) {
        level = i;
        if (likleihood < likelihood_categories[i].level ) {
            break
        }
    }

    let color = "#535353"
    let bcolor = "rgb(196,196,196)";
    let alpha = 1
    let label = likelihood_categories[level].name
    if (level === 3) {
        bcolor = "rgba(48,104,33," + alpha + ")";
        color = "rgb(206,238,208)";
    }
    if (level === 2) {
        bcolor = "rgba(206,238,208," + alpha + ")";
        color = "rgb(48,104,33)";
    }
    if (level === 1) {
        bcolor = "rgba(252,236,166," + alpha + ")";
        color = "rgb(152,96,34)";
    }
    if (level === 0) {
        bcolor = "rgba(251,84,81," + alpha + ")";
        color = "rgb(104,4,0)";
    }


    return (
        <Tooltip title={label}>
            <Chip
                size="small"
                label={name? name : label}
                color="primary"
                style={{backgroundColor: bcolor, color: color}}
            />
        </Tooltip>
    )

}

export const Consequence = (h: IHarm, name?:string) => {
    if (!h.consequence)
        return WarningChip(name?name:"undefined")

    let level = h.consequence.level

    let color = "#535353"
    let bcolor = "rgb(196,196,196)";
    let alpha = 1

    if (level > 0) {
        bcolor = "rgba(206,238,208," + alpha + ")";
        color = "rgb(48,104,33)";
    }
    if (level > 3) {
        bcolor = "rgba(252,236,166," + alpha + ")";
        color = "rgb(152,96,34)";
    }
    if (level > 6) {
        bcolor = "rgba(251,84,81," + alpha + ")";
        color = "rgb(104,4,0)";
    }

    return (
        <div>
            <Tooltip title={h.consequence.name}>
                <Chip
                    size="small"
                    label={name? name : h.consequence.name}
                    color="primary"
                    style={{backgroundColor: bcolor, color: color}}
                />
            </Tooltip>
        </div>
    )
}

const Likelihood: FC<ILikelihoodProps> = ({
                                  severities,
                                  failure_mode,
                                              critical_hazard
                              }) => {


    return (
        <>
            <TableRow>
                <TableCell>
                </TableCell>
                <TableCell>{failure_mode.failure_mode?.name}</TableCell>
                <TableCell>{critical_hazard?.max_annual_failure_probability.toExponential(1)}</TableCell>
                <TableCell>{render_likelihood_pill(critical_hazard?.max_annual_failure_probability || -1)}</TableCell>

            </TableRow>
        </>
    );
}

export default Likelihood


